import PropTypes from "prop-types"
import React, {useEffect, useState} from "react"
import {Link} from "gatsby"
import {IoMenu, IoClose} from "react-icons/io5";
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'
import NavItem from "./nav-item";

const fullConfig = resolveConfig(tailwindConfig)
const menuHiddenThreshold = parseInt(fullConfig.theme.screens.sm, 10);

const Header = ({ siteTitle }) => {

  const [menuHidden, setMenuHidden] = useState(true);

  const [windowDimensions, setWindowDimensions] = useState({
    width: 1,
    height: 1
  });

  useEffect(() => {
    const getWindowDimensions = () => {
      const { innerWidth: width, innerHeight: height } = window;
      return {
        width,
        height
      };
    }

    setWindowDimensions(getWindowDimensions())

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nav = [
    { label: 'Gallery', url: '/gallery' },
    { label: 'About', url: '/about' },
    // { label: 'Contact', url: '/contact' },
  ]

  const toggleMenu = () => {
    setMenuHidden(!menuHidden);
  }

  return (
    <header className="bg-primary text-white font-normal">
      <nav className="py-3 pb-4 px-6 text-xl flex flex-col sm:flex-row sm:items-center">
        <div className="flex-grow flex justify-between">
          <Link to='/' className="no-underline font-brand text-4xl">{siteTitle}</Link>
          <button className="sm:hidden text-3xl bg-transparent p-0" onClick={toggleMenu}>
            { menuHidden ? <IoMenu/> : <IoClose/>}
          </button>
        </div>
        <div className={`flex flex-col sm:gap-4 mt-4 sm:mt-0 sm:flex-row ${!menuHidden || windowDimensions.width >= menuHiddenThreshold ? 'block' : 'hidden'}`}>
          {nav.map((navItem, index) => (
            <NavItem key={`nav-item-${index}`} label={navItem.label} url={navItem.url}/>
          ))}
        </div>
      </nav>
    </header>
  );
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
